import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b9574f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-view" }
const _hoisted_2 = { class: "chat-box-container d-flex flex-col flex-item-grow" }
const _hoisted_3 = {
  class: "chat-item-box w-100",
  ref: "chatItemEl"
}
const _hoisted_4 = { class: "chat-input" }
const _hoisted_5 = { class: "send-btns d-flex flex-row align-items-center gap-8" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-send" }, null, -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-attachments" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatBubble = _resolveComponent("ChatBubble")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_FileChooser = _resolveComponent("FileChooser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatItems, (item, index) => {
          return (_openBlock(), _createBlock(_component_ChatBubble, {
            onClick: ($event: any) => (_ctx.onClick(item)),
            onPreviewLoaded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChatUpdate())),
            key: index,
            item: item,
            "is-last": index === _ctx.chatItems.length - 1,
            active: _ctx.isActive(item)
          }, null, 8, ["onClick", "item", "is-last", "active"]))
        }), 128)),
        (_ctx.typing)
          ? (_openBlock(), _createBlock(_component_ChatBubble, {
              key: 0,
              item: _ctx.typingMessage
            }, null, 8, ["item"]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("form", {
      class: "m-t-16",
      ref: "chatForm",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ion_textarea, {
          ref: "chatInput",
          "auto-grow": "",
          rows: "1",
          minlength: "1",
          maxlength: "2048",
          autocapitalize: "on",
          autocorrect: "on",
          autocomplete: "on",
          placeholder: this.$mhat('ChatView.MessagePlaceHolder'),
          type: "text",
          value: _ctx.value,
          onKeypress: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["enter"]),
          onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focusin'))),
          onFocusout: _ctx.focusOutDelay,
          onIonChange: _ctx.onChange
        }, null, 8, ["placeholder", "value", "onKeypress", "onFocusout", "onIonChange"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            title: _ctx.$mhat('ChatView.SendMessageTooltip')
          }, [
            _createVNode(_component_ion_fab_button, {
              onClick: _withModifiers(_ctx.send, ["stop"]),
              disabled: !_ctx.canSendTextMessage,
              type: "submit",
              size: "small",
              class: "chat-input-send-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ], 8, _hoisted_6),
          _createElementVNode("div", { title: _ctx.sendFileTooltip }, [
            _createVNode(_component_ion_fab_button, {
              disabled: !_ctx.canSendFileMessage,
              type: "submit",
              size: "small",
              class: "chat-input-send-attach-btn"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FileChooser, {
                  name: "attachment-file-selector",
                  onChooseFiles: _ctx.sendFiles,
                  disabled: !_ctx.canSendFileMessage,
                  accept: _ctx.allowedAttachmentFileExtensions,
                  buttonProps: {
							              'pattern': _ctx.ButtonColorPattern.TRANSPARENT,
							              'color': _ctx.canSendFileMessage ? _ctx.ButtonColor.GREYSCALE_LIGHT : _ctx.ButtonColor.GREYSCALE_DARK,
							             },
                  showButton: true
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onChooseFiles", "disabled", "accept", "buttonProps"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 8, _hoisted_8)
        ])
      ])
    ], 544)
  ]))
}